import React, { useEffect } from "react";
import {Box, Container, Fab, CircularProgress, Backdrop} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useAppBar } from '../../providers/AppBarProvider';

const ViewPage = ({ 
  children, 
  isLoading,
}) => {

  // const { toggleCloseIcon } = useAppBar();

  // useEffect(() => {
  //   toggleCloseIcon(true);
    
  //   // Cleanup function to hide the close icon when component unmounts
  //   return () => {
  //     toggleCloseIcon(false);
  //   };
  // }, [toggleCloseIcon]); // Solo depende de toggleCloseIcon

  return (
    <Container maxWidth="xl" disableGutters sx={{ pt: 0, pb: 0 }}>

      {!isLoading && (
        <>
          {children}
        </>
      )}

      {isLoading && (
        <>
          <CircularProgress
            size={42}
            sx={{ position: 'absolute', top: '50%', left: '50%', marginTop: '-21px', marginLeft: '-21px' }}
          />
        </>
      )}

    </Container>
  );
};

export default ViewPage;
